const init = () => {
    if (document.body.classList.contains('article-page')) {
        //we need to run through the .article-page .content div and remap the inline styles to the classes
        const content = document.querySelector('.article-page .content .component__container');
        
        if (content) {
            //we then need to loop through all direct children of the content div and remap the inline styles to the classes
            const children = content.children;
            Array.from(children).forEach(child => {
                // Check for inline styles in the HTML attribute (even if blocked by CSP)
                const inlineStyleString = child.getAttribute('style');
                
                if (inlineStyleString) {
                    console.log('Found style attribute:', inlineStyleString);
                    
                    // Parse all inline styles
                    const textAlignMatch = inlineStyleString.match(/text-align\s*:\s*([^;]+)/i);
                    const borderCollapseMatch = inlineStyleString.match(/border-collapse\s*:\s*([^;]+)/i);
                    const backgroundColorMatch = inlineStyleString.match(/background-color\s*:\s*([^;]+)/i);
                    const borderColorMatch = inlineStyleString.match(/border-color\s*:\s*([^;]+)/i);
                    const borderStyleMatch = inlineStyleString.match(/border-style\s*:\s*([^;]+)/i);
                    const widthMatch = inlineStyleString.match(/width\s*:\s*([^;]+)/i);

                    // Handle text-align
                    if (textAlignMatch) {
                        const textAlignValue = textAlignMatch[1].trim();
                        console.log('Found text-align in style attribute:', textAlignValue);
                        
                        if (textAlignValue === 'left') {
                            child.classList.add('align-left');
                            console.log('added align-left class');
                        } else if (textAlignValue === 'right') {
                            child.classList.add('align-right');
                            console.log('added align-right class');
                        } else if (textAlignValue === 'center') {
                            child.classList.add('align-center');
                            console.log('added align-center class');
                        }
                    }

                    // Handle border-collapse
                    if (borderCollapseMatch) {
                        const borderCollapseValue = borderCollapseMatch[1].trim();
                        console.log('Found border-collapse:', borderCollapseValue);
                        if (borderCollapseValue === 'collapse') {
                            child.classList.add('border-collapse');
                            console.log('added border-collapse class');
                        }
                    }

                    // Handle background-color
                    if (backgroundColorMatch) {
                        const backgroundColorValue = backgroundColorMatch[1].trim();
                        console.log('Found background-color:', backgroundColorValue);
                        if (backgroundColorValue === '#ffffff' || backgroundColorValue === 'white') {
                            child.classList.add('bg-white');
                            console.log('added bg-white class');
                        }
                    }

                    // Handle border-color
                    if (borderColorMatch) {
                        const borderColorValue = borderColorMatch[1].trim();
                        console.log('Found border-color:', borderColorValue);
                        if (borderColorValue === '#ffffff' || borderColorValue === 'white') {
                            child.classList.add('border-white');
                            console.log('added border-white class');
                        }
                    }

                    // Handle border-style
                    if (borderStyleMatch) {
                        const borderStyleValue = borderStyleMatch[1].trim();
                        console.log('Found border-style:', borderStyleValue);
                        if (borderStyleValue === 'none') {
                            child.classList.add('border-none');
                            console.log('added border-none class');
                        }
                    }

                    // Handle width
                    if (widthMatch) {
                        const widthValue = widthMatch[1].trim();
                        console.log('Found width:', widthValue);
                        if (widthValue === '100%') {
                            child.classList.add('w-full');
                            console.log('added w-full class');
                        }
                    }

                    // Remove the inline style attribute after processing all styles
                    child.removeAttribute('style');
                    console.log('removed inline style attribute');
                } else {
                    console.log('No style attribute found');
                }
            });
        }
    }
};

export default init;